import style from './MainAvisos.module.css';

export default function MainAvisos({ children }) {
    return (
        <main className={style.mainAvisos}>
            {children}
        </main>
    );
}
